import { render, staticRenderFns } from "./CodemirrorInput.vue?vue&type=template&id=4df2a81a&"
import script from "./CodemirrorInput.vue?vue&type=script&lang=js&"
export * from "./CodemirrorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports